export interface TopicItem {
  id: string;
  title: string;
  intro: string;
  cover: string;
  tag: string;
}

export const topicList: TopicItem[] = [
  {
    id: "autumn-2026-new",
    title: "2026 秋季新番前瞻",
    intro: "本季最值得期待的十二部新作一次看全，从硬科幻到治愈日常，总有一部戳中你。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20seasonal%20preview%20collage%20style%20artwork%20with%20warm%20orange%20autumn%20leaves%20and%20glowing%20city%2C%20cel%20shaded%20promotional%20visual%2C%20clean%20background&width=640&height=440&seq=topic-autumn-2026&orientation=landscape",
    tag: "新番",
  },
  {
    id: "healing-therapy",
    title: "治愈系精选集",
    intro: "累了就来这里充电。精选十部温柔到骨子里的治愈动画，陪你度过每个安静夜晚。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20anime%20illustration%20of%20a%20warm%20room%20with%20plants%20and%20soft%20sunlight%2C%20cream%20and%20amber%20tones%2C%20cel%20shaded%20healing%20atmosphere%2C%20clean%20background&width=640&height=440&seq=topic-healing&orientation=landscape",
    tag: "治愈",
  },
  {
    id: "guofeng-rising",
    title: "国风动画崛起",
    intro: "水墨、留白、东方美学——国产动画正在用自己的语言，讲述属于这片土地的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=chinese%20ink%20painting%20style%20anime%20landscape%20with%20mountains%20and%20floating%20lanterns%2C%20warm%20orange%20accents%2C%20watercolor%20cel%20shaded%20background%2C%20elegant&width=640&height=440&seq=topic-guofeng&orientation=landscape",
    tag: "国创",
  },
  {
    id: "scifi-odyssey",
    title: "科幻与星辰大海",
    intro: "从方舟飞船到赛博都市，这些作品把人类的想象推向了宇宙的尽头。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20space%20odyssey%20artwork%20with%20spaceship%20and%20distant%20planet%2C%20warm%20orange%20nebula%20glow%2C%20cinematic%20cel%20shaded%20background&width=640&height=440&seq=topic-scifi&orientation=landscape",
    tag: "科幻",
  },
];